export default __webpack_public_path__ + "static/media/poweredByBayad.98193f63.png";